import React from 'react';
import { BillDetail } from './BillDetail';

export default function BillDetailPage() {
  return <BillDetail />;
}